<section class="mobile-navbar-dialog-content" aria-labelledby="mobile-general-search-title">
  <header class="mobile-navbar-dialog-header">
    <h2 id="mobile-general-search-title">Busca geral</h2>
    <button type="button" mat-icon-button aria-label="Fechar busca" (click)="close()">
      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>
  </header>

  <div class="mobile-search-input-wrapper">
    <i class="fa-solid fa-search" aria-hidden="true"></i>
    <input
      #searchInput
      type="search"
      class="form-control"
      placeholder="Buscar tarefas, projetos e clientes"
      [value]="filterText"
      (input)="onSearchInput($any($event.target).value)"
      (keydown.enter)="$event.preventDefault(); searchFirstResult()"
    >
  </div>

  <div class="mobile-navbar-dialog-results" aria-live="polite">
    <div class="mobile-navbar-dialog-status" *ngIf="isLoading">Buscando...</div>
    <div class="mobile-navbar-dialog-status" *ngIf="!isLoading && !filterText">Digite para iniciar a busca.</div>
    <div class="mobile-navbar-dialog-status" *ngIf="!isLoading && hasSearched && results.length === 0">Nenhum resultado encontrado.</div>

    <section class="mobile-search-result-group" *ngFor="let result of results">
      <h3>{{ result.route }}</h3>
      <button
        type="button"
        class="mobile-search-result"
        *ngFor="let entity of result.generalEntity"
        (click)="openResult(result.route, entity.id)"
      >
        {{ entity.name }}
        <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
      </button>
    </section>
  </div>
</section>
